import { GET_INVENTORY_COUNT } from 'actions/types';

const initialState = {
  users: { count: 0, package_total: 0 },
  assets: { count: 0, package_total: 0 },
  inventory: { count: 0, package_total: 0 },
};
export function inventoryCount(state = initialState, action) {
  const { type, payload } = action;
  if (type === `${GET_INVENTORY_COUNT}_SUCCESS`) {
    return payload;
  }
  return state;
}
